import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param slotData: object
// example:
// {
//   "day_of_the_week": "sunday",
//   "start_time": "10:00",
//   "end_time":"20:00"
// }
export function createTutorScheduleSlot(
  slotData: object
): Promise<ApiResponse> {
  return Axios.post(`v1/tutors/schedule_slots`, { data: slotData });
}

export function deleteTutorScheduleSlot(slotId: number): Promise<ApiResponse> {
  return Axios.delete(`v1/tutors/schedule_slots/${slotId}`);
}

export function indexTutorSchedulesSlot(): Promise<ApiResponse> {
  return Axios.get("/v1/tutors/schedule_slots");
}
export function indexTutorAvailable(): Promise<ApiResponse> {
  return Axios.get("/v1/tutors/schedule_request_groups/availability");
}
